import * as React from "react";
import "./spinner.css";
import { ReactComponent as SpinnerSVG } from "./spinner.svg";
import { ferryColor } from "../ui/styleVars";

export const Loader: React.FC = () => {
  return <SpinnerSVG color={ferryColor} />;
};
